import { EditorContent } from '@tiptap/react'
import styled from 'styled-components'

export const RichControlsWrapper = styled.div`
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid var(--tds-divider-light);
  background-color: var(--tds-white);
  padding: var(--tds-spacing-element-8);
`

export const StyledEditorContent = styled(EditorContent)`
  outline: none;
  padding-top: 0;
  border-radius: 4px 4px 0 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: none;
  outline: none;
  height: 100%;
  color: var(--tds-textarea-color);
  background-color: var(--tds-textarea-background);
  font: var(--tds-detail-02);
  letter-spacing: var(--tds-detail-02-ls);
  padding: var(--tds-spacing-element-20) var(--tds-spacing-element-16);
  display: block;
  resize: vertical;
  border-bottom: 1px solid var(--tds-textarea-border-bottom);
  transition: border-bottom-color 200ms ease;

  .ProseMirror {
    outline: none;
    padding: 0;
    margin: 0;
    border: none;
  }
  .ProseMirror-focused {
    outline: none;
  }
`

export const StyledContentWrapper = styled.div`
  /* padding: 20px 16px 20px 16px; */
`

//copy of editor main element
export const StyledTextContent = styled.div<{ hasError?: boolean }>`
  white-space: break-spaces;
  overflow-wrap: break-word;
  outline: none;
  padding-top: 0;
  border-radius: 4px 4px 0 0;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: none;
  outline: none;
  height: 100%;
  color: var(--tds-textarea-color);
  background-color: var(--tds-textarea-background);
  font: var(--tds-detail-02);
  letter-spacing: var(--tds-detail-02-ls);
  padding: var(--tds-spacing-element-20) var(--tds-spacing-element-16);
  display: block;
  resize: vertical;
  border-bottom: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--tds-textarea-border-bottom-error)'
        : 'var(--tds-textarea-border-bottom)'};
  transition: border-bottom-color 200ms ease;
`

export const StyledFakeToolbarDiv = styled.div`
  height: 49px;
`

export const StyledTextfieldData = styled.div`
  height: auto;
`

export const StyledTextareaContainer = styled.div<{ hasError?: boolean }>`
  position: relative;
  height: auto;
  width: 100%;
  min-width: 208px;
  display: inline-flex;
  background-color: transparent;
  flex-flow: row wrap;
  border-bottom: 0;
`

export const StyledTextareaWrapper = styled.div`
  position: relative;
  width: unset;
  min-width: 100%;
  padding-top: 8px;
`

export const StyledTextareaHelper = styled.div`
  font: var(--tds-detail-05);
  letter-spacing: var(--tds-detail-05-ls);
  display: flex;
  gap: 8px;
  align-items: center;
  padding-top: var(--tds-spacing-element-4);
  flex-grow: 2;
  flex-basis: auto;
`

export const StyledTextareaCounter = styled.div<{
  modeVariant?: 'primary' | 'secondary'
}>`
  font: var(--tds-detail-05);
  letter-spacing: var(--tds-detail-05-ls);
  color: var(--tds-textarea-textcounter);
  float: right;
  text-align: right;
  padding-top: var(--tds-spacing-element-4);
  background-color: ${({ modeVariant }) =>
    modeVariant === 'secondary' ? 'var(--tds-white)' : 'var(--tds-grey-50)'};
`

export const StyledTextcounterDivider = styled.span`
  font: var(--tds-detail-05);
  letter-spacing: var(--tds-detail-05-ls);
  color: var(--tds-textarea-textcounter-divider);
`
